import * as ActionTypes from './actions';
import * as AuthActionTypes from '../../auth/actions';
import update from 'immutability-helper';
import { processErrorResponse } from '../../common/middleware/api';

const initialState = {
	search: '',
	individualConsultationSearch: '',
	programId: null,
	centerId: null,
	termId: null,
	gradeId: null,
	date: null,
	lessonType: '',
	selectedChildId: 0,
	selectedPaymentTypeId: 0,
	isPrepaid: null,
	selectedPaymentMethodName: '',
	isBonusLesson: null,
	annualPaymentLength: null,
	isSelectJoinWaitingList: false,
	childrenPaymentTypes: [],	//{ childId: 1, paymentTypes: [] }
	errorMessage: null,
	workshopErrorMessage: null,
	selectedWorkshopSessionIds: [],
	paymentMethodsByCenter: {},
	instalmentPlans: [],
	fetchingBookingOptions: false,
	promoCodeErrorMessage: '',
	cancellationReason: '',
	result: {
		success: false,
		errorMessage: '',
		status: '',
		paymentId: 0,
		requiresRedirection: false,
		redirectUrl: '',
		httpBodyParams: null,
		successMessage: ''
	}
};

const booking = (state = initialState, action) => {
	switch (action.type) {
		case AuthActionTypes.LOGOUT:
			return initialState;
		case ActionTypes.UNSELECT_LESSON:
		case ActionTypes.UNSELECT_PROGRAM_ITEM:
			return update(state, {
				programId: { $set: null },
				date: { $set: null },
				isSelectJoinWaitingList: { $set: false }
			});
		case ActionTypes.STORE_SEARCH_QUERY:
			return update(state, {
				search: { $set: action.payload }
			});
		case ActionTypes.STORE_INDIVIDUAL_CONSULTATION_SEARCH_QUERY:
			return update(state, {
				individualConsultationSearch: { $set: action.payload }
			});
		case ActionTypes.SELECT_PROGRAM_ITEM:
			return update(state, {
				programId: { $set: action.payload },
				date: { $set: null },
				warningMessage: { $set: null },
				errorMessage: { $set: null },
				upcomingLessons: { $set: [] },
				childrenPaymentTypes: { $set: [] }
			});
		case ActionTypes.BOOKING_OPTIONS_FETCH_REQUEST:
			return update(state, {
				programId: { $set: action.payload.programId },
				centerId: { $set: action.payload.centerId },
				date: { $set: action.payload.date },
				lessonType: { $set: action.payload.lessonType },
				childrenPaymentTypes: { $set: [] },
				instalmentPlans: { $set: [] },
				selectedChildId: { $set: action.payload.childId },
				selectedPaymentTypeId: { $set: 0 },
				isPrepaid: { $set: null },
				isSelectJoinWaitingList: { $set: false },
				selectedPaymentMethodName: { $set: '' },
				isBonusLesson: { $set: null },
				annualPaymentLength: { $set: null },
				warningMessage: { $set: null },
				errorMessage: { $set: null },
				upcomingLessons: { $set: [] },
				fetchingBookingOptions: { $set: true }
			});
		case ActionTypes.BOOKING_OPTIONS_FETCH_SUCCESS:
			return update(state, {
				warningMessage: { $set: action.response.warningMessage },
				errorMessage: { $set: action.response.errorMessage },
				upcomingLessons: { $set: action.response.upcomingLessons || [] },
				childrenPaymentTypes: { $set: action.response.childrenPaymentTypes || [] },
				fetchingBookingOptions: { $set: false }
			});
		case ActionTypes.BOOKING_OPTIONS_FETCH_FAILURE:
			const optionsFetchErrors = processErrorResponse(action.errorResponse);
			return update(state, {
				errorMessage: { $set: optionsFetchErrors.message },
				fetchingBookingOptions: { $set: false }
			});
		case ActionTypes.PAYMENT_METHODS_FETCH_REQUEST:
			return update(state, {
				paymentMethodsByCenter: {
					[action.centerId]: { $set: [] }
				}
			});
		case ActionTypes.PAYMENT_METHODS_FETCH_SUCCESS:
			return update(state, {
				paymentMethodsByCenter: {
					[action.centerId]: { $set: action.response }
				}
			});
		case ActionTypes.INSTALMENT_PLANS_FETCH_REQUEST:
			return update(state, {
				instalmentPlans: { $set: [] }
			});
		case ActionTypes.INSTALMENT_PLANS_FETCH_SUCCESS:
			return update(state, {
				instalmentPlans: { $set: action.response }
			});
		case ActionTypes.SELECT_CHILD:
			return update(state, {
				selectedChildId: { $set: action.payload }
			});
		case ActionTypes.SELECT_PAYMENT_TYPE:
			return update(state, {
				selectedPaymentTypeId: { $set: action.payload.paymentTypeId },
				isPrepaid: { $set: action.payload.isPrepaid },
				isBonusLesson: { $set: action.payload.isBonusLesson },
				annualPaymentLength: { $set: action.payload.annualPaymentLength }
			});
		case ActionTypes.SELECT_JOIN_WAITING_LIST:
			return update(state, {
				isSelectJoinWaitingList: { $set: true }
			});
		case ActionTypes.SELECT_CONSULTATION_DATE:
			return update(state, {
				date: { $set: action.payload },
				programId: { $set: null },
				errorMessage: { $set: null }
			});
		case ActionTypes.SELECT_CENTER:
			return update(state, {
				centerId: { $set: action.payload }
			});
		case ActionTypes.SELECT_TERM:
			return update(state, {
				termId: { $set: action.payload }
			});
		case ActionTypes.SELECT_GRADE:
			return update(state, {
				gradeId: { $set: action.payload }
			});
		case ActionTypes.SELECT_LESSON_TYPE:
			return update(state, {
				lessonType: { $set: action.payload }
			});
		case ActionTypes.SELECT_WORKSHOP_SESSIONS:
			return update(state, {
				selectedWorkshopSessionIds: { $set: action.payload }
			});
		case ActionTypes.BOOKING_CREATE_SUCCESS:
		case ActionTypes.INDIVIDUAL_CONSULTATION_CREATE_SUCCESS:
			// reset to initial state with only 'result' populated
			return update(initialState, {
				result: {
					success: { $set: true },
					status: { $set: action.response.status },
					paymentId: { $set: action.response.paymentId }
				},
				// keep already loaded payment methods
				paymentMethodsByCenter: { $set: state.paymentMethodsByCenter },
				// keep cancellation reason if payment was created as a copy of a cancelled payment
				cancellationReason: { $set: state.cancellationReason }
			});
		case ActionTypes.WAITING_LIST_JOIN_SUCCESS:
			// reset to initial state with only 'result' populated
			return update(initialState, {
				result: {
					success: { $set: true },
					successMessage: {
						$set: action.response.message
					}
				},
				// keep already loaded payment methods
				paymentMethodsByCenter: { $set: state.paymentMethodsByCenter }
			});
		case ActionTypes.INDIVIDUAL_CONSULTATION_CREATE_FAILURE:
			const consultationErrors = processErrorResponse(action.errorResponse);
			return update(state, {
				result: {
					success: { $set: false },
					errorMessage: { $set: consultationErrors.message }
				},
				date: { $set: null }
			});
		case ActionTypes.WORKSHOP_BOOKING_CREATE_REQUEST:
			return update(state, {
				workshopErrorMessage: { $set: null }
			});
		case ActionTypes.WORKSHOP_BOOKING_CREATE_FAILURE:
			const workshopBookingErrors = processErrorResponse(action.errorResponse);
			return update(state, {
				workshopErrorMessage: { $set: workshopBookingErrors.message }
			});
		case ActionTypes.PAYMENT_METHOD_SELECT_REQUEST:
			return update(state, {
				cancellationReason: { $set: null },
				result: {
					errorMessage: { $set: null }
				}
			});
		case ActionTypes.BOOKING_CREATE_FAILURE:
		case ActionTypes.PAYMENT_START_FAILURE:
		case ActionTypes.PAYMENT_POST_FAILURE:
		case ActionTypes.PAYMENT_END_FAILURE:
		case ActionTypes.WAITING_LIST_JOIN_FAILURE:
		case ActionTypes.PAYMENT_METHOD_SELECT_FAILURE:
			const bookingErrors = processErrorResponse(action.errorResponse);
			return update(state, {
				result: {
					success: { $set: false },
					errorMessage: { $set: bookingErrors.message }
				}
			});
		case ActionTypes.PAYMENT_CANCELLED:
			return update(state, {
				cancellationReason: { $set: action.payload }
			});
		case ActionTypes.PAYMENT_END_SUCCESS:
			return update(state, {
				result: {
					success: { $set: true },
					requiresRedirection: { $set: action.response.requiresRedirection },
					redirectUrl: { $set: action.response.redirectUrl },
					httpBodyParams: { $set: action.response.httpBodyParams }
				}
			});
		case ActionTypes.APPLY_PROMO_CODE_REQUEST:
			return update(state, {
				promoCodeErrorMessage: { $set: '' }
			});
		case ActionTypes.APPLY_PROMO_CODE_FAILURE:
		case ActionTypes.REMOVE_PROMO_CODE_FAILURE:
			const promoCodeErrors = processErrorResponse(action.errorResponse);
			return update(state, {
				promoCodeErrorMessage: { $set: promoCodeErrors.message }
			});
		case ActionTypes.RESET_BOOKING:
			return update(initialState, {
				paymentMethodsByCenter: { $set: state.paymentMethodsByCenter }
			});
		default:
			return state;
	}
};

export default booking;
